<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169209977351127383955731462195.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169209998067706087908094692662.jpg",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914255085809717361676830216.png",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicAbout.vue